import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import { __decorate } from "tslib";
import { orderRecordDetail } from '@/services/http';
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
import { formatNum as _formatNum } from '@/tools/tools';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.menus = [{
      title: '提交记录',
      isOpen: true,
      child: [{
        id: 1,
        title: '代打印',
        link: '/user',
        name: 'user'
      }, {
        id: 11,
        title: '耗材定制',
        link: '/coupon',
        name: 'coupon'
      }]
    }];
    _this.name = '';
    _this.currentIndex = Number(_this.$route.query.showType);
    _this.infor = {};
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.getInforDetails();
    }
  }, {
    key: "goList",
    value: function goList(num) {
      this.currentIndex = num;
      this.$router.push("/consumables-orderlist?currentIndex=".concat(this.currentIndex));
    }
  }, {
    key: "getInforDetails",
    value: function () {
      var _getInforDetails = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this$$route$query, showType, id, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$$route$query = this.$route.query, showType = _this$$route$query.showType, id = _this$$route$query.id;
              _context.next = 3;
              return orderRecordDetail({
                showType: showType,
                id: id
              });
            case 3:
              res = _context.sent;
              this.infor = res.data.data;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getInforDetails() {
        return _getInforDetails.apply(this, arguments);
      }
      return getInforDetails;
    }()
  }]);
}(Vue);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer,
    BackTop: BackTop
  },
  filters: {
    formatNum: function formatNum(value) {
      return _formatNum(value);
    }
  }
})], default_1);
export default default_1;